import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button, Panel, PageHeader, Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import QuestionnaireReview from './QuestionnaireReview';

export const SubmitQuestionnaire = ({ questions, answers, units, busy, submit, back }) => {

  return (
    <div id="submit-questionnaire">
      <PageHeader>Submit Questionnaire</PageHeader>
      <Panel >
        <p>All the necessary questions have been completed.</p>
        <Alert bsStyle="info">
          <p>Please take a moment to <strong>review</strong> the answers, and then click <strong>Submit</strong> to proceed.</p>
        </Alert>

        <QuestionnaireReview questions={questions} answers={answers} units={units}/>
      </Panel>
      <ButtonToolbar>
        <Button bsSize="large" onClick={back} disabled={busy}>
          {!busy && <FontAwesome name='arrow-left' />}
          {busy && <FontAwesome name='spinner' spin />}
          &nbsp;Back</Button>
        <Button bsStyle="primary" bsSize="large" onClick={submit} disabled={busy}>
          Submit&nbsp;
          {!busy && <FontAwesome name='check' />}
          {busy && <FontAwesome name='spinner' spin />}</Button>
      </ButtonToolbar>
    </div>
  )
}

SubmitQuestionnaire.propTypes = {
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  units: PropTypes.array,
  busy: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/submitQuestionnaire/SubmitQuestionnaire.js